export default "__VITE_ASSET__Ztx4EQM9__"